import React, { useEffect, useState } from 'react'
import { Popup } from '../../components/Popup'
import { Button } from '../../components/Button';
import { createFinishedRoute } from '../../redux/advertSlice';
import { Input } from '../../components/Input';
import { useDispatch, useSelector } from 'react-redux';
import { Select } from '../../components/Select';

export const CreateFinishRoutePopup = ({closeFn, routeId, cityId}) => {
    const dispatch = useDispatch();
    const flyerTypes = useSelector((state) => state.settings.flyerTypes);

    const routes = useSelector((state) => state.advert.routes);
    const cities = useSelector((state) => state.settings.advertCities);
    const promoters = useSelector((state) => state.advert.promoters);

    const [city, selectCity] = useState(cityId || cities[0]?._id || 'null');
    const thisCityPromoters = promoters.filter(p => p.city._id === city);
    const [prom, selectProm] = useState(thisCityPromoters[0]?._id || 'null');
    const [thisRoute, setThisRoute] = useState(routeId || 0);

    const [pageIndex, setPageIndex] = useState(1);

    const [selectedFlyers, selectFlyers] = useState([]);
    const selectFlyerHandler = (id) => {
        if (selectedFlyers.some(f => f === id)) {
            selectFlyers(prev => prev.filter(f => f !== id));
            return;
        }
        selectFlyers(prev => [...prev, id]);
    }
    const [bet, setBet] = useState(0.01);

    useEffect(() => {
        const thisProm = promoters.find(p => p._id === prom);
        setBet(thisProm?.bet || 0.01);
    }, [prom])
    
    const [porchAmount, setPorchAmount] = useState(0);
    const [offsetOwnPositive, setOffsetOwnPositive] = useState(0);
    const [offsetPositive, setOffsetPositive] = useState(0);
    const [offsetNegative, setOffsetNegative] = useState(0);
    const [offsetComment, setOffsetComment] = useState('');

    const additional = {
        addPorchCount: porchAmount,
        plusPaymentOwn: offsetOwnPositive,
        plusPayment: offsetPositive,
        minusPayment: offsetNegative,
        addPaymentComment: offsetComment,
    }

    const [assignDate, setAssignDate] = useState(new Date().toDateString())
    const [givenCount, setGivenCount] = useState(0);
    const [returnCount, setReturnCount] = useState(0);
    const [spreadFlyers, setSpreadFlyers] = useState([{dayStamp: new Date().toDateString(), count: 0}])
    const setSpreadFlyersHandler = (index, dayStamp, count) => {
        setSpreadFlyers(prev => prev.map((sf, i) => i !== index ? sf : ({...sf, dayStamp: dayStamp || sf.dayStamp, count: count !== null ? count : sf.count})))
    }
    useEffect(() => {
        if (!spreadFlyers.some(sf => sf.count === 0)) {
            setSpreadFlyers(prev => [...prev, {dayStamp: new Date().toDateString(), count: 0}])
        }
    }, [spreadFlyers])

    const [needPay, setNeedPay] = useState(false);

    const [isReqSended, setReqSended] = useState(false);

    const hasPartnerFlyers = selectedFlyers.some(fId => !flyerTypes.find(f => f._id === fId).isOwn)

    useEffect(() => {
        if (!hasPartnerFlyers) {
            setOffsetPositive(0)
        }
    }, [selectedFlyers])

    const createHandler = () => {
        const body = {
            city,
            promoterId: prom,
            routeId: routes.find(r => r.id === thisRoute && r.city._id === city)?._id || null,
            bet,
            flyerIds: selectedFlyers,

            assignStamp: +new Date(assignDate),
            givenCount,
            returnCount,
            spreadFlyers: spreadFlyers.filter(sf => sf.count),

            additional,
            needPay
        }
        setReqSended(true);
        dispatch(createFinishedRoute({...body, closeFn, enableBtn: () => setReqSended(false)}));
    }

    const [focusIndex, setFocusIndex] = useState(0);

    const FirstPage = () => {
        return (
            <div className="finish-route-popup__section">
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', rowGap: '8px'}}>
                        <Select label="Город" enums={cities} value={city} changeHandler={(e) => selectCity(e.target.value)}/>
                        <Select style={{marginLeft: 'auto'}} label="Пром" enums={[...thisCityPromoters].sort((a,b) => a.fullname.localeCompare(b.fullname))} value={prom} changeHandler={(e) => selectProm(e.target.value)}/>
                        <Input tabIndex={0} autoFocus={focusIndex === 0} focusHandler={() => setFocusIndex(0)} label='№ маршрута' type='number' value={thisRoute} changeHandler={(e) => setThisRoute(+e.target.value)} />
                        <Input tabIndex={1} autoFocus={focusIndex === 1} focusHandler={() => setFocusIndex(1)} style={{marginLeft: 'auto'}} type='number' min={0.01} step={0.01} label="Ставка" value={bet} changeHandler={(e) => setBet(+e.target.value)} />
                    </div>
                    <div className='button-list' style={{marginTop: '16px', display: 'flex', columnGap: '16px', justifyContent: 'center'}}>
                        {flyerTypes.map(f => 
                        <Button key={f._id}
                        classNames={`${selectedFlyers.some(f2 => f2 === f._id)?'active':''}`}
                        text={f.name}
                        onClick={() => selectFlyerHandler(f._id)} />
                    )}
                </div>
            </div>
        )
    }
    const SecondPage = () => {
        return (
            <div className="finish-route-popup__section">
               <div style={{display: 'flex', justifyContent: 'space-between', rowGap: '8px', marginBottom: '12px'}}>
                    <Input type='date' label='Когда выдан' value={assignDate} changeHandler={(e) => setAssignDate(e.target.value)}/>
                    <Input tabIndex={2} autoFocus={focusIndex === 2} focusHandler={() => setFocusIndex(2)} type="number" min={0} label='Листовок выдано' value={givenCount} changeHandler={(e) => setGivenCount(+e.target.value)}/>
                    <Input tabIndex={3} autoFocus={focusIndex === 3} focusHandler={() => setFocusIndex(3)} type="number" min={0} max={givenCount} label='Листовок возвращено' value={returnCount} changeHandler={(e) => setReturnCount(+e.target.value)}/>
               </div>
                <p>Укажите, сколько и в какие дни было разнесено листовок</p>
               <div>
                {spreadFlyers.map((sf, index) => <div key={`${sf.dayStamp}_${index}`} style={{display: 'flex', columnGap: '8px', margin: '8px 0', justifyContent: 'center', alignItems: 'flex-end'}}>
                    <Input type='date' label={index ? '':'Когда разнесено'} value={sf.dayStamp} changeHandler={(e) => setSpreadFlyersHandler(index, e.target.value, null)}/>
                    <Input tabIndex={10+index} autoFocus={focusIndex === 10+index} focusHandler={() => setFocusIndex(10+index)} type="number" min={0} label={index ? '':'Сколько разнесено'} value={sf.count} changeHandler={(e) => setSpreadFlyersHandler(index, null, +e.target.value)}/>
                    <div style={{cursor: 'pointer'}} onClick={() => setSpreadFlyers(prev => prev.filter((_, i) => index !== i))}>X</div>
                </div>)}
               </div>
            </div>
        )
    }
    const ThirdPage = () => {
        return (<>
            <div className="finish-route-popup__section">
                <p>Укажите количество подъездов, в которых листовки были оставлены у консьержа или на подоконнике</p>
                <div style={{display: 'flex', columnGap: '8px', alignItems: 'flex-end'}}>
                    <Input tabIndex={4} autoFocus={focusIndex === 4} focusHandler={() => setFocusIndex(4)} min={0} label='Кол-во подъездов' type='number' value={porchAmount} changeHandler={(e) => setPorchAmount(+e.target.value)}/>
                    <span>x 20л. = {+porchAmount*20} листовок = + {(+porchAmount*20*bet).toFixed(2)} руб прому</span>
                </div>
            </div>
            <div className='route-additional-popup__section'>
                <p>Укажите суммы, которые нужно прибавить и убавить от общей суммы маршрута (бонусы, штрафы)</p>
                <div>
                    <div>
                        <Input tabIndex={5} autoFocus={focusIndex === 5} focusHandler={() => setFocusIndex(5)} min={0} label='Личные начисления, руб' type='number' value={offsetOwnPositive} changeHandler={(e) => setOffsetOwnPositive(Math.abs(+e.target.value))} />
                        {hasPartnerFlyers && <Input tabIndex={6} autoFocus={focusIndex === 6} focusHandler={() => setFocusIndex(6)} min={0} label='Общие начисления, руб' type='number' value={offsetPositive} changeHandler={(e) => setOffsetPositive(Math.abs(+e.target.value))} />}
                        <Input tabIndex={7} autoFocus={focusIndex === 7} focusHandler={() => setFocusIndex(7)} min={0} label='Отчисления, руб' type='number' value={offsetNegative} changeHandler={(e) => setOffsetNegative(Math.abs(+e.target.value))} />
                    </div>
                    <Input style={{width: '100%'}} tabIndex={8} autoFocus={focusIndex === 8} focusHandler={() => setFocusIndex(8)} value={offsetComment} placeholder='Комментарий (необязательно)' changeHandler={(e) => setOffsetComment(e.target.value)} />
                </div>
            </div>
            <div className='route-additional-popup__section'>
                <div style={{justifyContent: 'center'}}><input id='pay-route' type='checkbox' checked={needPay} onChange={() => setNeedPay(prev => !prev)}/><label htmlFor='pay-route' style={{marginLeft: '6px'}}>Добавить маршрут на оплату</label></div>
                <p><span style={{fontWeight:'bold', fontSize:'1.1m', color:'red'}}>ВАЖНО! </span>После создания пройденного маршрута вам нужно будет вручную установить блокировку</p>
            </div>
        </>)
    }

    return (
      <Popup closeWithOutsideClick={false} title='Завершить маршрут вручную' closeFn={closeFn}
      button={<>
        {pageIndex > 1 && <Button text="Назад" onClick={() => setPageIndex(prev => prev-1)}/>}
        {pageIndex < 3 && <Button text="Далее" onClick={() => setPageIndex(prev => prev+1)}/>}
        {pageIndex === 3 && <Button disabled={isReqSended} text="Сохранить" onClick={createHandler}/>}
        </>}>
            <div className='finish-route-popup'>
                {pageIndex === 1 && <FirstPage />}
                {pageIndex === 2 && <SecondPage />}
                {pageIndex === 3 && <ThirdPage />}
            </div>
    </Popup>
    )
}
